import { Http } from "@/plugins/http.js";

export class TasksResultRepository {
  /**
   * @param {number} customerId
   * @param {TaskEventItemValue} eventData
   * @returns {Promise<any>}
   */
  static async updateValue(customerId, eventData) {
    const { data } = await Http.put(`/v1/customers/${customerId}/events/result`, { events: [eventData] });

    return data;
  }
}
